import React from "react";
import styled from "styled-components"
import { Link } from "react-router-dom";

const Button = styled(Link)`
    display: inline-block;
    background-color: white;
    font-size: 16px !important;
    line-height: 1em;
    padding: 8px 16px !important;
    color: black !important;
    border: 1px solid #333;
    text-decoration: none;
    border-radius: 5px;
    transition: transform .2s;

    svg {
        margin-right: 10px;
    }

    &:hover {
        transform: scale(1.1);
    }
`

function MoreInfoButton({show}) {
  return (
        <Button to={show.url}>
            More Info
        </Button>
  );
}

export default MoreInfoButton;